import React, { Fragment, useState } from 'react';
import { t } from 'i18n';

import Icon from 'Components/Base/Icon';

import DataLogs from './DataLogs';

const i18nOpts = { scope: 'audit.index' };

const AuditEvents = ({ logs }) => {
  const [isExpanded, setIsExpanded] = useState({});

  return <table className="audit-log-table">
    <thead>
      <tr className="table__head">
        <th />
        <th>{t('table_header.time', i18nOpts)}</th>
        <th>{t('table_header.user_name', i18nOpts)}</th>
        <th>{t('table_header.user_id', i18nOpts)}</th>
        <th>{t('table_header.method', i18nOpts)}</th>
        <th>{t('table_header.path', i18nOpts)}</th>
        <th>{t('table_header.params', i18nOpts)}</th>
        <th>{t('table_header.response_status', i18nOpts)}</th>
        <th>{t('table_header.user_agent', i18nOpts)}</th>
        <th>{t('table_header.user_ip', i18nOpts)}</th>
      </tr>
    </thead>

    <tbody>
      {
        logs.map(({
          requestUuid,
          time,
          userName,
          userId,
          kind,
          method,
          path,
          params,
          errorStatus,
          userAgent,
          ip,
          dataLogs,
        }, i) => <Fragment key={`requst-log-${i}`}>
            <tr
              className={`${dataLogs?.length ? 'audit-log-table__expandable' : ''} ${isExpanded[requestUuid] ? 'is-expanded' : 'is-collapsed'}`.trim()}
              onClick={() => {
                if (!dataLogs?.length) return;

                setIsExpanded(prev => ({
                  ...prev,
                  [requestUuid]: !prev[requestUuid],
                }));
              }}
            >
              <td>
                {
                  !!dataLogs?.length && (
                    <>
                      <Icon name="chevron-down" className="collapsed_icon" />
                      <Icon name="chevron-up" className="expanded_icon" />
                    </>
                  )
                }
              </td>
              <td className="audit-log-table__timestamp_column">
                {time}
              </td>
              <td>{userName}</td>
              <td>{userId}</td>
              <td>
                {
                  kind === 'request'
                    ? method
                    : t('row.navigate', { ...i18nOpts, type: method })
                }
              </td>
              <td>{path}</td>
              <td>{JSON.stringify(params)}</td>
              <td>
                {
                  errorStatus
                    ? t('row.error', i18nOpts)
                    : t('row.success', i18nOpts)
                }
              </td>
              <td>{userAgent}</td>
              <td>{ip}</td>
            </tr>
            {
              !!dataLogs?.length && <DataLogs
                isExpanded={isExpanded[requestUuid]}
                logs={dataLogs}
              />
            }
          </Fragment>
        )
      }
    </tbody>
  </table>;
};

export default AuditEvents;
